var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,48.5v-9a6,6,0,0,1,6-6h17V7.5H7.5v49h28V53A6,6,0,0,1,33.5,48.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.75,
    y1: 22.91,
    x2: 37.25,
    y2: 41.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 10.5,
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,15.71V9.5m0,45V48.29M43.52,20.48l4.39-4.39M16.09,47.91l4.39-4.39m0-23-4.39-4.39M47.91,47.91l-4.39-4.39M15.71,32H9.5m45,0H48.29",
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    values: "0 32 32; 360 32 32",
    repeatCount: "indefinite",
    type: "rotate"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.69,46.56A1.87,1.87,0,0,0,43,47c1.17,0,1.76-.52,1.76-1.56V39.57a.66.66,0,0,1,.12-.45.64.64,0,0,1,.44-.12h1.12a.46.46,0,0,1,.57.57v5.77A3.5,3.5,0,0,1,46,48a4.17,4.17,0,0,1-3,1,4.14,4.14,0,0,1-3-1,3.5,3.5,0,0,1-1-2.68V39.57a.46.46,0,0,1,.57-.57h1.12a.6.6,0,0,1,.43.12.66.66,0,0,1,.12.45V45.4A1.47,1.47,0,0,0,41.69,46.56Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.44,39.56l-3.17,9a.72.72,0,0,1-.25.38.81.81,0,0,1-.45.1H52.44a.89.89,0,0,1-.45-.09.63.63,0,0,1-.24-.36l-3.19-9c-.14-.37,0-.56.37-.56h1a1.6,1.6,0,0,1,.73.11.67.67,0,0,1,.3.41l1.63,5.25c.06.23.13.48.19.77s.1.5.13.67l0,.25h.11a9.3,9.3,0,0,1,.35-1.67l1.6-5.27a.61.61,0,0,1,.3-.41,1.51,1.51,0,0,1,.71-.11h1C57.46,39,57.58,39.19,57.44,39.56Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvIndex);
export default __webpack_public_path__ + "static/media/uv-index.9f34e74f8f3ed49439fbcd85dacca89d.svg";
export { ForwardRef as ReactComponent };